export default "__VITE_ASSET__lztX7A8E__";